import { render, staticRenderFns } from "./GroupNotice.vue?vue&type=template&id=4d2b7307&scoped=true"
import script from "./GroupNotice.vue?vue&type=script&lang=js"
export * from "./GroupNotice.vue?vue&type=script&lang=js"
import style0 from "./GroupNotice.vue?vue&type=style&index=0&id=4d2b7307&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b7307",
  null
  
)

export default component.exports